import { render, staticRenderFns } from "./ProductSalesPageIntroduction.vue?vue&type=template&id=cecfa1f6&scoped=true&"
import script from "./ProductSalesPageIntroduction.vue?vue&type=script&lang=ts&"
export * from "./ProductSalesPageIntroduction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cecfa1f6",
  null
  
)

export default component.exports